(() => {
  if (window.IslanderAnalytics || window.Shopify?.designMode) return;
  const script = document.querySelector('script[data-islander-analytics]');
  const page = script?.dataset.pageType || 'page';
  const debug = new URLSearchParams(location.search).get('islander_debug') === '1';
  const faqGroups = '.islander-workshop-faq__items, .islander-private-events__faq-list, .islander-contact__faq-list, .stores-story__faq-list, .islander-support__category-content, .islander-support__disclosures, .collapsible-content__wrapper';
  const newsletterSelector = 'form[action*="/contact"]:has(input[name="contact[tags]"][value*="newsletter"])';
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const pageGroup = () => page === 'index' ? 'main' : page === 'collection' ? 'collection' : page === 'product' ? 'product' : /faq/.test(location.pathname) ? 'faq' : /workshop/.test(location.pathname) ? 'workshop' : 'page';
  const position = (element) => element.closest('footer') ? 'footer' : element.closest('.islander-workshop-hero') ? 'workshop_hero' : element.closest('header') ? 'header' : element.closest('.islander-home-hero') ? 'home_hero' : 'content';

  function emit(name, parameters = {}) {
    if (!allowed()) return false;
    const payload = { event_name: name, page: pageGroup(), position: parameters.position || 'content', ...parameters };
    if (debug) payload.debug_mode = true;
    try {
      const result = window.Shopify?.analytics?.publish?.('islander:interaction', payload);
      result?.catch?.(() => {});
      window.clarity?.('event', name);
      if (debug) document.dispatchEvent(new CustomEvent('islander:analytics-debug', { detail: payload }));
      return true;
    } catch { return false; }
  }
  window.IslanderAnalytics = Object.freeze({ version: '1.1.0' });

  // Use confirmed theme outcomes. Never forward error messages or search terms.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data } = {}) => {
      if (data?.variant?.id) emit('product_variant_selected', { availability: data.variant.available ? 'available' : 'unavailable' });
    });
    subscribe(PUB_SUB_EVENTS.cartError, () => emit('cart_error', { error_type: 'add_to_cart_failed' }));
  }
  document.addEventListener('islander:collection:changed', () => emit('collection_navigation'));
  // OpenCX renders its launcher in an iframe; observe only the public dialog state.
  let chatOpen = false;
  const chatObserver = new MutationObserver(() => {
    const open = document.querySelector('#opencx-root [role="dialog"][aria-label="Support chat"]')?.getAttribute('data-state') === 'open';
    if (open && !chatOpen) emit('cl_support_chat', { position: 'chat' });
    chatOpen = open;
  });
  chatObserver.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-state'] });
  let searchReported = false;
  function checkSearchResults() {
    const count = Number(script?.dataset.searchResults);
    if (page !== 'search' || script?.dataset.searchPerformed !== 'true' || searchReported || !Number.isInteger(count) || count < 0) return;
    searchReported = emit('search_results', { result_count: count, result_status: count === 0 ? 'empty' : 'found' });
  }

  document.addEventListener('click', (event) => {
    const path = event.composedPath();
    const target = path.find((node) => node?.matches?.('a, button, summary, input[type="submit"]'));
    if (!target || target.disabled || target.getAttribute('aria-disabled') === 'true') return;
    const where = position(target);
    const link = target.closest('a[href]');
    let url;
    try { if (link) url = new URL(link.href, location.origin); } catch { return; }
    const experimentDebug = link?.getAttribute('data-islander-experiment-debug') === 'true' ? { debug_mode: true } : {};
    if (link?.matches('.islander-home-workshop__button')) {
      emit('cl_book_workshop_body', { position: where, ...experimentDebug });
      return;
    }
    if (link?.matches('.islander-workshop-booking, .islander-workshop-hero .button--primary') || (url?.hostname === 'fareharbor.com' && url.pathname.startsWith('/embeds/book/islanderuk/'))) {
      // Workshop page clicks are emitted once by its consent-gated page tracker.
      if (link.closest('main') && document.querySelector('[data-workshop-experiment]')) return;
      emit(where === 'workshop_hero' ? 'cl_book_workshop_hero' : 'cl_book_workshop_site', { position: where, ...experimentDebug });
      return;
    }
    if (target.matches('[data-search-toggle], .header__icon--search, .search__button')) {
      emit('cl_search', { position: where });
    } else if (target.matches('[name="add"], [data-islander-native-submit]')) {
      emit('cl_add_to_basket', { position: where, page: target.closest('product-recommendations') ? 'similar items' : pageGroup() });
    } else if (target.closest(newsletterSelector) && target.matches('button[type="submit"], input[type="submit"]')) {
      emit('cl_subscribed', { position: where });
    } else if (target.matches('localization-form a[data-value]') && target.closest('localization-form')?.querySelector('[name="country_code"]')) {
      const country = target.dataset.value;
      const previous = target.closest('localization-form').querySelector('[name="country_code"]').value;
      if (/^[A-Z]{2}$/.test(country) && country !== previous) emit('cl_change_country', { country_code: country, position: where });
    } else if (url?.protocol === 'tel:' || url?.protocol === 'mailto:') {
      emit('contact_click', { method: url.protocol === 'tel:' ? 'phone' : 'email', position: where });
    } else if (url && (url.hostname === 'maps.google.com' || url.hostname === 'maps.app.goo.gl' || url.hostname === 'maps.apple.com' || (/(^|\.)google\.[a-z.]+$/.test(url.hostname) && url.pathname.startsWith('/maps')))) {
      emit('directions_click', { position: where });
    }
    // Capture the launcher only, never messages or other controls inside chat.
    if (path.some((node) => node?.localName === 'shopify-chat') && (target.matches('[aria-expanded="false"]') || /^(chat with us|open chat)$/i.test(target.getAttribute('aria-label') || ''))) {
      emit('cl_support_chat', { position: 'chat' });
    }
  }, true);

  document.addEventListener('toggle', (event) => {
    const item = event.target;
    if (item.matches?.('details') && item.open && item.closest(faqGroups)) {
      const siblings = [...item.closest(faqGroups).querySelectorAll('details')];
      emit('cl_faq_workshop', { faq_index: siblings.indexOf(item) + 1 });
    }
  }, true);

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!input.closest?.('facet-filters-form')) return;
    if (input.name?.startsWith('filter.')) emit('product_filter', { filter_type: input.name.replace(/[^a-zA-Z0-9_.]/g, '').slice(0, 60) });
    if (input.name === 'sort_by') emit('product_sort', { sort_order: /^[a-z-]+$/.test(input.value) ? input.value : 'other' });
  });

  document.addEventListener('submit', (event) => {
    if (!event.target.matches?.(newsletterSelector) || !allowed()) return;
    try { sessionStorage.setItem('islander_newsletter_pending', String(Date.now())); } catch { /* Storage may be unavailable. */ }
  }, true);

  function checkNewsletterSuccess() {
    if (!allowed() || !document.querySelector('[data-islander-newsletter-success]')) return;
    try {
      const timestamp = Number(sessionStorage.getItem('islander_newsletter_pending'));
      sessionStorage.removeItem('islander_newsletter_pending');
      if (timestamp > 0 && Date.now() - timestamp < 600000) emit('newsletter_signup', { position: 'footer' });
    } catch { /* No persistent identifier or form values are stored. */ }
  }
  document.addEventListener('visitorConsentCollected', () => {
    if (!allowed()) {
      try { sessionStorage.removeItem('islander_newsletter_pending'); } catch { /* Storage may be unavailable. */ }
    }
    checkNewsletterSuccess();
    checkSearchResults();
  });
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => { if (!error) { checkNewsletterSuccess(); checkSearchResults(); } });
  } else { checkNewsletterSuccess(); checkSearchResults(); }
})();
